module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"sendTest":"Send test","sendTestMessage":"{emailCount} test email has been sent to {emailTo} | {emailCount} test emails have been sent to {emailTo}","errorSendingTest":"There was a problem sending the test emails"}}')
  delete Component.options._Ctor
}
